import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { paths } from 'routes/paths';
import Button from 'screens/Integrations/components/IntegrationButton';

import Breadcrumb from 'components/App/AppShell/components/Breadcrumb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import StoreIcon from 'components/Icons/StoreIcon';

const landingPageDefaultPropImgStyle = {
  width: 'auto',
  height: 'auto'
};
const LandingPage = ({
  buttonText = 'Start New Submission',
  byText = 'By',
  breadcrumbText,
  ownerText,
  headerText,
  targetPath,
  LogoImg = undefined,
  imgStyle = landingPageDefaultPropImgStyle
}) => {
  const history = useHistory();

  return (
    <>
      <Breadcrumb hideCropSeasonDropdown disabled>
        <Breadcrumb.Item title="Integrations" value={breadcrumbText} isLast />
      </Breadcrumb>
      <div className="flex flex-col w-full items-start mt-5">
        <Button
          variant="outline"
          icon={
            <FontAwesomeIcon
              fixedWidth
              size="1x"
              icon={faChevronLeft}
              color="#696F88"
            />
          }
          onClick={() => history.replace(`${paths.integrations}`)}
        >
          Back
        </Button>
        <div className="mt-3 w-full border-b flex gap-5 items-center justify-between rounded-lg pt-2 pb-6">
          <div className="flex">
            {LogoImg ? (
              <div className="bg-white rounded-xl shadow-md border p-6">
                <img
                  src={LogoImg}
                  alt=""
                  style={imgStyle}
                  data-testid={`logo-${targetPath}`}
                />
              </div>
            ) : (
              <div>
                <div className="bg-green-200 p-2 rounded-full mt-2">
                  <div className="m-1">
                    <StoreIcon size={24} color="green-700" />
                  </div>
                </div>
              </div>
            )}
            <div className="pl-5 flex flex-col justify-center">
              <h3 className="font-bold text-2xl">{headerText}</h3>
              <h2>{`${byText} ${ownerText}`}</h2>
            </div>
          </div>
          <Button
            variant="primary"
            size="lg"
            onClick={() => {
              history.push(`${paths.integrations}/${targetPath}`);
            }}
          >
            <span className="pl-6 pr-6">{buttonText}</span>
          </Button>
        </div>
      </div>
    </>
  );
};

LandingPage.propTypes = {
  buttonText: PropTypes.string,
  byText: PropTypes.string,
  breadcrumbText: PropTypes.string.isRequired,
  ownerText: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  targetPath: PropTypes.string.isRequired,
  LogoImg: PropTypes.shape({
    type: PropTypes.oneOf(['svg', 'png'])
  }),
  imgStyle: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string
  })
};

export default LandingPage;
